var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gt-initing"},[_c('GtLoading'),_c('p',{staticClass:"gt-initing__text"},[_vm._v(" 載入中 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }